import React from 'react';

import { Icon } from 'design-system-web';
import { useTranslation } from 'react-i18next';

import { ShopifyBurstReviewSectionTitle } from 'lane-shared/types/integrations/ShopifyBurst';

import { M } from 'components/typography';

import ReviewData from './ReviewData';

type Props = {
  burstName: string;
  onClick?: () => void;
};

export default function ReviewName({ burstName, onClick }: Props) {
  const { t } = useTranslation();

  return (
    <ReviewData
      title={t(ShopifyBurstReviewSectionTitle.BurstName)}
      titleIcon={<Icon set="FontAwesome" name="pen-square" type="far" />}
      onClick={onClick}
      summary={<M variant="secondary">{burstName}</M>}
      isEditable
    />
  );
}
